<!--
 * @Author: your name
 * @Date: 2022-01-04 13:05:22
 * @LastEditTime: 2022-02-09 18:27:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \longzhu-PC\src\App.vue
-->
<template>
  <div id="app">
    <!-- <Nav></Nav> -->
    <!-- <keep-alive> -->
    <p v-if="invalidRoute">404</p>
    <!-- <keep-alive> -->
    <router-view v-if="isRouterAlive" />
    <!-- </keep-alive> -->
  </div>
</template>
<script>
  import Nav from './component/Nav.vue'
  import {
    GloubleSocket
  } from '@/lib/scoreSocket.js'
  import URLS from '@/api/lz.js'
  import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2
  import {
    registerIM
  } from '@/api/wyapi.js'
  // import { initNIM} from '@/js_sdk/wysocket.js'
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    async mounted() {

      // let patams = {
      //   "device": "",
      //   "channel": "",
      //   "grayTheme": true,
      //   "minimumVersion": "",
      //   "currentVersion": "",
      //   "popUp": 0,
      //   "popupContent": "",
      //   "forceUpdate": 0,
      //   "hideModule": "",
      //   "downloadUrl": "",
      //   "createTime": 0
      // }
      // localStorage.setItem('userSettingInfo',JSON.stringify(patams));

      console.log('环境。。。。。。。。。。。。。', process.env)
      const script = document.createElement('script')
      script.src = 'https://s9.cnzz.com/z_stat.php?id=1280646369&web_id=1280646369'
      script.language = 'JavaScript'
      document.body.appendChild(script);
      // 如果用户登录
      //  if(localStorage.getItem('token')){
      // let wyuserinfo = localStorage.getItem('wyuserinfo');
      // console.log('是否有缓存网易云信',wyuserinfo);
      //    // 获取用户信息
      //    let userdata = await registerIM();
      //    if(userdata.data.code == 200){
      //      let userinfo = userdata.data.data;
      //      console.log('初始化网易云信',userinfo);
      //      localStorage.setItem('wyuserinfo',JSON.stringify(userinfo))
      //      // initNIM(userinfo);
      //    }
      //  }
      this.initGlobalSocket()
      // 您不应在页面加载时或加载后直接运行指纹。 而是使用setTimeout或requestIdleCallback将其延迟几毫秒，以确保指纹一致。
      if (window.requestIdleCallback) {
        // if(!localStorage.getItem('browserId')){
        requestIdleCallback(() => {
          this.createFingerprint();
        });
        // }
      } else {
        setTimeout(() => {
          this.createFingerprint();
        }, 500);
      }



    },
    methods: {
      // 创建浏览器指纹
      createFingerprint() {
        // 浏览器指纹
        const fingerprint = Fingerprint2.get((components) => { // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
          const values = components.map(component => component.value); // 配置的值的数组
          const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
          // console.log(components);
          // console.log(values);
          // console.log(murmur);
          localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
        });
      },
      // 初始化socket
      initGlobalSocket() {
        console.log('成功1。。。。。。。。。。。。。。。。。。。。。。。', URLS);
        let socket = GloubleSocket({
          userid: 0,
          url: URLS.ScopeSocketUrl
        }, (data) => {
          console.log('成功2。。。。。。。。。。。。。。。。。。。。。。。');
        })
      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function() {
          this.isRouterAlive = true
        })
      }
    },
    beforeDestroy() {
      localStorage.removeItem('wyuserinfo')
    },
    components: {
      Nav
    },
    watch: {
      $route() {
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          // window._czc.push(['load', contentUrl, refererUrl])
        }
      }
    },
    computed: {
      invalidRoute() {
        // console.log(this.$route.matched);
        return !this.$route.matched || this.$route.matched.length === 0;
      }

    },
  }
</script>
<style scopend>
  * {
    margin: 0;
    padding: 0;
    /* box-sizing: border-box;  */
  }

  html,
  body {
    font-size: 16px;
    height: -webkit-fill-available;
  }

  div,
  span {
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .filterbgsno{
    -webkit-filter : grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  }
  /*每个页面公共css */
  /*  .myfont1 {
  	overflow: hidden; //隐藏文字
  	text-overflow: ellipsis; //显示 ...
  	white-space: nowrap; //不换
  }
  .myfont2 {
  	    word-break: break-all;
  	    text-overflow: ellipsis;
  	    display: -webkit-box;
  	    -webkit-box-orient: vertical;
  	    -webkit-line-clamp: 2;
  	    overflow: hidden;
  } */
  .myfont1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
   .changePopoverItempopover{
      border: none !important;
      min-width: 30px !important;
      background-color:#333 ;
      color: #fff;
   
    }
   .changePopoverItempopover .changePopover{
      display: flex;
      width: 30px;
      flex-direction: column;
      justify-content: center;
    }
    .changePopoverItempopover  .changePopoverItem{
      text-align: center;
      height: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 12px;
      cursor: pointer;
      margin-bottom: 16px;
    }
     .changePopoverItempopover  .changePopoverItemActive{
      color:   #8DB1FF !important;
    }
     .changePopoverItempopover  .changePopoverItem:hover{
      color:   #8DB1FF !important;
      cursor: pointer;
    }
     .changePopoverItempopover  .changePopoverItem:last-child{
      margin-bottom: 0;
    }
  .popDownAPPs {
    width: 439px !important;
    height: 173px;
    background: #FFFFFF;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0;
  }

  .popDownAPPs .downAPP {
    display: flex;
    padding:16px 36px !important;
  }

  .popDownAPPs .downAPP .liveHelps ,.itemAPP{
    display: flex;
    flex-direction: column;
    align-items: center;
  justify-content: center;
  }

  .popDownAPPs .downAPP .livetitles {
    font-size: 14px;      font-family: PingFangSC-Medium, PingFang SC;     font-weight: 600;     color: #333333;
  }
  .popDownAPPs .liveDowns:hover{
    color:#721EDC ;
  }
  .el-popover{
      border: 0px solid rgba(0, 0, 0, 0) !important;
  }
  .AnchorTaskBox{
    padding: 0px !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
   .popDownAPPs  .livetitles{
     height: 20px;
     font-size: 14px;
     font-family: PingFangSC-Medium, PingFang SC;
     font-weight: 600;
     color: #333333;
     line-height: 20px;
     margin-bottom: 12px;
   }
  .popDownAPPs .liveDowns{
    margin-top: 12px;
    height: 17px;
    cursor: pointer;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
  }

  .popDownAPPs .liveHelps img {
    width: 86px;
    height: 72px;
  }
  .popDownAPPs .downAPP .lines{
    display: flex;
    width:1px;
    height: 132px;
    margin: 0 36px;
    background:#D8D8D8;
  }
  .popDownAPPs .itemAPP img {
    width: 80px;
    height: 80px;
  }
  .RooMpopTaskBox {
    padding: 0;
    margin: 0;
    background: none;
    /* border-radius: 8px; */
    overflow: hidden;
    background-color: none;
    width: 386px !important;
    /* border: 1px solid #ec9b59; */
    box-sizing: border-box;
  }

  .RooMpopTaskBox .popper__arrow:after {
    /* background: #ec9b59; */
    border-top-color: #ec9b59 !important;
  }


  .popTaskBox {
    padding: 0;
    background: none;
    border-radius: 4px;
  }

  .popTaskBox .popper__arrow:after {
    /* background: #721EDC; */
    border-bottom-color: #721EDC !important;
  }


  .el-input__inner:focus {
    border: 1px solid #d6d8df;
  }

  .elementHove {
    transition: all .1s;
  }

  .elementHove .newel {
    display: none;
  }

  .elementHove .oldel {
    display: block;
  }

  .elementHove:hover .newel {
    display: block;
  }

  .elementHove:hover .oldel {
    display: none;
  }
  .changePopoverOpenToppack{
    padding: 0;
    border-radius: 4px;
    min-width:400px;
    cursor: pointer;
  }
  .changePopovercloseGigt {
    padding: 0;
    border-radius: 4px;
    min-width: 130px;
    max-width: 350px;
    cursor: pointer;
  }
  .minroomhoverSoftBox{
    padding: 0 !important;
  }
  .minroomhoverSoftBox .hoverSoftList{
    width: 252px;
    display: flex;
    flex-flow: row wrap;
    transition: all .6s;
    padding: 12px;
    box-sizing: border-box;
  }
  .minroomhoverSoftBox .hoverSoftBoxItem{
    margin: 6px;
    text-align: center;
    width: 64px;
    height: 26px;
    line-height: 26px;
    background: #F7F8FA;
    border-radius: 4px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .minroomhoverSoftBox .hoverSoftBoxItem:hover{
    cursor: pointer;
    background-color: #721EDC;
    color: #FFFFFF;
  }
  .changePopoverOpenzimu{
    padding:4px;
    width: 296px;
    min-height: ;: 80px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.15);
    border-radius: 4px;
    cursor: pointer;
  }
  .changePopoverOpenzimu .hoverOpenzimu{
    display: flex;
    flex-flow:row wrap;
  }
  .changePopoverOpenzimu .hoverOpenzimu .hoverOpenzimuItem{
    display: flex;
    box-sizing: border-box;
    padding: 2px 10px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #EBEEF3;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #333333;
    margin: 4px;
  }
   .changePopoverOpenzimu .hoverOpenzimu .hoverOpenzimuItem:hover{
     background-color: #721EDC;
     color: #fff;
     transition: all .25s;
   }

  .changePopovercloseGigt .changePopovercloseGigtContent {
    padding: 8px 6px;
    text-align: center;
    cursor: pointer;
  }

  /* 全屏 */
  .prism-big-play-btn {
    cursor: pointer;
    position: absolute;
  }

  .prism-big-play-btn .outter {
    z-index: 1000 !important;

  }

  /* 播放器去黑边 */
  .prism-player {
    background: rgba(0, 0, 0, .1) !important;
    text-align: center !important;
  }

  /* 字体超出省略 */
  .myfont {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

  }


  .useall {
    user-select: all !important;

  }

  /* 隐藏滚动条 */
  .outer-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }

  .inner-container {
    position: absolute;
    left: 0;
    top: 0;
    right: -17px;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  /* 渐变进度条 */
  .el-bg-inner-running .el-progress-bar__inner {
    background-color: unset;
    background: linear-gradient(90deg, #1E6ADB 0%, #721EDC 100%);
  }

  /*  */
  .personal-bottom-bottom-left .el-collapse-item__content {
    padding-bottom: 0px !important;
  }

  .el-bg-inner-running .el-progress-bar__innerText {
    color: rgba(0, 0, 0, 0);
  }

  .personal {
    width: 100% !important;
  }

  .personal-bottom {
    width: 100% !important;
    /* height: 92vh; */
    /* min-width: 1350px !important; */
    /* min-height: 950px; */
    /* background-color: #292929; */
    /* background-color: red; */
  }

  html {
    font-size: 16px;
  }

  @media screen and (min-width:1440px) {
    html {
      font-size: 16px;
    }
  }

  @media screen and (min-width:1920px) {
    html {
      /* font-size: 20px; */
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue